/*
 * @Author: kuangxj 
 * @Email: frankxjkuang@gmail.com 
 * @Date: 2018-07-10 11:35:39 
 * @Last Modified by: kaungxj
 * @Last Modified time: 2018-07-10 11:36:40
 * @Description: File desctiption 
 */
import MoorSwitch from './moor-switch';

MoorSwitch.install = Vue => Vue.component(MoorSwitch.name, MoorSwitch);

export default MoorSwitch;


// WEBPACK FOOTER //
// ./src/packages/switch/index.js